import {Button, Col, Divider, Popconfirm, Radio, Row, Space, Typography} from "antd";
import { DeleteOutlined } from '@ant-design/icons'
import React, {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import AntForm, { useAntForm } from "@9troisquarts/ant-form";
import {contactInformationsSchema, offerDetailsSchema, offerInformationsSchema, keywordsSchema} from "./schemas";
import useOffer from "../Offer/useOffer";
import {push, replace} from "connected-react-router";
import {useDispatch} from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import "../../../../../../../../node_modules/@9troisquarts/ant-form/dist/style.css"

const OfferForm = (props) => {
  const {
    admin = true,
    extraVariables = {}
  } = props;
  const { set, onChange, object: offer } = useAntForm(props.offer || { });
  const intl = useIntl();
  const dispatch = useDispatch();
  const [value, setValue] = useState(1);
  const onRadioChange = e => {
    setValue(e.target.value);
  };

  useEffect(() => set(props.offer || {}), [props.offer?.id]);
  
  const [errors, setErrors] = useState({});

  const { onSave, onDelete } = useOffer(offer?.id, {
    onCompleted: (data: any) => {
      const { recordErrors, createOffer, updateOffer } = data;
      if (recordErrors) setErrors(recordErrors);
      else if(createOffer?.offer || updateOffer?.offer) {
        if (props.onCompleted) {
          props.onCompleted(createOffer?.offer || updateOffer?.offer);
        } else {
          dispatch(push(`/admin/offers/${updateOffer?.offer?.id || createOffer?.offer?.id}`));
        }
      }
    },
  });

  useEffect(() => setErrors({}), []);

  const handleDelete = () => onDelete({
    onCompleted: () => {
      dispatch(replace(`/admin/offers`))
    }
  })

  return (
    <>
      <Row gutter={32} style={{ marginBottom: 30 }}>
        <Col xs={24} md={12}>
          <Typography.Title level={3} key="offer-informations-title">
            {intl.formatMessage({ id: 'sentences.offer_informations' })}
          </Typography.Title>
          <AntForm
            // @ts-ignore
            schema={offerInformationsSchema(intl)}
            object={offer}
            errors={errors}
            // @ts-ignore
            onChange={onChange}
            layout="vertical"
          />
        </Col>
        <Col xs={24} md={12}>
        <Typography.Title level={3} key="contact-informations-title">
          {intl.formatMessage({ id: 'sentences.employer_contact_informations' })}
        </Typography.Title>
          <AntForm
            // @ts-ignore
            schema={contactInformationsSchema(intl, admin)}
            object={offer}
            errors={errors}
            // @ts-ignore
            onChange={onChange}
            layout="vertical"
          >
          </AntForm>
        </Col>
      </Row>
      <Row gutter={32} style={{ marginBottom: 30 }}>
        <Col xs={24}>
          <Typography.Title level={3} key="offer-details">
            {intl.formatMessage({ id: 'words.details' })}
          </Typography.Title>
          <Radio.Group onChange={onRadioChange} value={value}>
            <Radio value={1}>Rédiger l'offre</Radio>
            <Radio value={2}>Insérer un pdf</Radio>
          </Radio.Group>
          {value === 1 && (
            <AntForm
              // @ts-ignore
              schema={offerDetailsSchema(intl, admin)}
              object={offer}
              errors={errors}
              // @ts-ignore
              onChange={onChange}
              layout="vertical"
            />
            )}
          {value === 2 && (
            <Col xs={12} md={12} className={ `offer-tag lighten-background` } key="pdfUpload" style={{ borderRadius: 4, marginTop: 18, marginBottom: 12, paddingTop: 10 }}>
              <AntForm
                object={offer}
                schema={[
                  {
                    name: 'attachment',
                    input: {
                      type: 'upload',
                      accept: '.pdf',
                      inputProps: {
                        // @ts-ignore
                        addComponent: (
                          <a className={`tenant-color`}>
                            <FontAwesomeIcon icon={solid('plus')}  style={{ marginRight: 5 }} />
                            Insérer un pdf
                          </a>
                        ),
                      },
                    }
                  }
                ]}
                // @ts-ignore
                onChange={onChange}
              />
            </Col>
          )}
          <AntForm
            // @ts-ignore
            schema={keywordsSchema(intl)}
            object={offer}
            errors={errors}
            // @ts-ignore
            onChange={onChange}
            layout="vertical"
          />
          <Divider />
          <div style={{ textAlign: 'right' }}>
            <Space>
              {props.offer?.id && (
                <Popconfirm
                  title={intl.formatMessage({ id: 'sentences.are_you_sure'} )}
                  okText={intl.formatMessage({ id: 'words.yes_word' })}
                  cancelText={intl.formatMessage({ id: 'words.cancel' })}
                  // @ts-ignore
                  onConfirm={handleDelete}
                >
                  <Button type="default" danger >
                    <DeleteOutlined />
                    {intl.formatMessage({ id: 'words.delete' })}
                  </Button>

                </Popconfirm>
              )}
              <Button type="primary" onClick={() => onSave(offer || {}, { variables: extraVariables })}>
                {intl.formatMessage({ id: 'words.save' })}
              </Button>
            </Space>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default OfferForm;
